export enum UserTypeEnums {
  TEMPORARY_PASSWORD = 'TEMPORARY_PASSWORD',
  EMAIL_PASSWORD = 'EMAIL_PASSWORD'
}
